<app-multimarket-view
        [title]="'MULTIMARKET.LINKS_TO_PRIVACY_POLICY'"
        [marketField]="'privacyPolicyUrl'"
></app-multimarket-view>